import css from 'styled-jsx/css';
import { sansSerif, serif } from 'styles/css-constants';
import { sharedPalette, warmGrays } from 'styles/colors/constants';

export default css`
  .AmpProductTeaserListItem {
    position: relative;
    margin-bottom: 1.25rem;
    border-bottom: 1px solid ${warmGrays[2]};
    padding-bottom: 1.25rem;
    text-decoration: none;
  }

  .AmpProductTeaserListItem__body {
    margin-bottom: 1rem;
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
  }

  .AmpProductTeaserListItem__cake,
  .AmpProductTeaserListItem__description,
  .AmpProductTeaserListItem__name,
  .AmpProductTeaserListItem__retailer {
    flex: 0 0 100%;
    max-width: 100%;
  }

  .AmpProductTeaserListItem__cake {
    margin-bottom: 0.375rem;
    color: ${sharedPalette.darkWatermelon};
    font-family: ${sansSerif};
    font-size: var(--fontScaleNeg2);
    text-transform: uppercase;
  }

  .AmpProductTeaserListItem__comparisonPrice {
    margin-left: 0.25rem;
    color: ${warmGrays[6]};
    font-family: ${sansSerif};
    font-size: var(--fontScaleNeg1);
  }

  .AmpProductTeaserListItem__counter {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    height: 28px;
    min-width: 64px;
    background-color: #fff;
    font-family: ${sansSerif};
    font-size: 12.5px;
    line-height: 1;
  }

  .AmpProductTeaserListItem__cta,
  .AmpProductTeaserListItem__price,
  .AmpProductTeaserListItem__retailer,
  .AmpProductTeaserListItem__subtitle {
    font-family: ${sansSerif};
  }

  .AmpProductTeaserListItem__cta {
    margin: 0 auto;
    display: block;
    width: 260px;
    padding: 0.375rem;
    background-color: #000;
    color: #fff;
    font-size: var(--fontScaleNeg1);
    letter-spacing: 0.02em;
    text-align: center;
    text-transform: uppercase;
    -webkit-appearance: none;
    -moz-appearance: none;
  }

  .AmpProductTeaserListItem__description {
    font-family: ${serif};
    font-size: var(--fontScale1);
    line-height: 1.5;
  }

  .AmpProductTeaserListItem__description :global(a) {
    color: #000;
  }

  .AmpProductTeaserListItem__description :global(p) {
    margin: 0;
  }

  .AmpProductTeaserListItem__image {
    margin-bottom: 1rem;
    display: block;
  }

  .AmpProductTeaserListItem__name {
    margin-bottom: 0.25rem;
    color: #000;
    font-family: ${serif};
    font-size: var(--fontScale2);
    font-weight: bold;
  }

  .AmpProductTeaserListItem__name a {
    color: #000;
  }

  .AmpProductTeaserListItem__price {
    margin-bottom: 1rem;
    color: #000;
    font-size: var(--baseFontSize);
    font-weight: bold;
  }

  .AmpProductTeaserListItem__retailer {
    margin-bottom: 1rem;
    color: ${warmGrays[6]};
    font-size: var(--fontScaleNeg1);
    text-transform: uppercase;
  }

  .AmpProductTeaserListItem__subtitle {
    font-size: var(--fontScaleNeg1);
    font-weight: 600;
    margin-bottom: 0.25rem;
    text-transform: uppercase;
  }

  .AmpProductTeaserListItem__image {
    position: relative;
  }
`;
